import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-cream flex flex-col" data-id="element-205">
      <main className="flex-grow max-w-3xl mx-auto px-6 py-16 w-full" data-id="element-206">
        <Link to="/" className="inline-flex items-center text-navy hover:text-gold transition-colors mb-8 font-medium" data-id="element-207">
          <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-208" />
          Volver al inicio
        </Link>

        <article className="prose prose-navy max-w-none" data-id="element-209">
          <h1 className="font-heading text-4xl md:text-5xl text-navy mb-4" data-id="element-210">
            Política de Privacidad
          </h1>
          <p className="text-gray-500 mb-8" data-id="element-211">
            Última actualización: 21 de marzo de 2026
          </p>

          <div className="space-y-8 text-gray-700" data-id="element-212">
            <p className="text-lg" data-id="element-213">
              Valoramos tu privacidad. Esta Política de Privacidad explica cómo
              recopilamos, usamos y protegemos tu información cuando visitas
              este sitio web o nos contactas.
            </p>

            <section data-id="element-214">
              <h2 className="font-heading text-2xl text-navy mb-3" data-id="element-215">
                Información que recopilamos
              </h2>
              <ul className="list-disc pl-5 space-y-2" data-id="element-216">
                <li data-id="element-217">
                  Información que proporcionas voluntariamente (por ejemplo:
                  nombre, correo, teléfono y contenido de mensajes).
                </li>
                <li data-id="element-218">
                  Datos técnicos (por ejemplo: IP, navegador, dispositivo,
                  páginas visitadas y tiempo de permanencia) para analítica y
                  seguridad.
                </li>
              </ul>
            </section>

            <section data-id="element-219">
              <h2 className="font-heading text-2xl text-navy mb-3" data-id="element-220">
                Cómo usamos tu información
              </h2>
              <ul className="list-disc pl-5 space-y-2" data-id="element-221">
                <li data-id="element-222">
                  Para entregarte recursos solicitados (por ejemplo, el ebook).
                </li>
                <li data-id="element-223">
                  Para responder consultas y brindarte apoyo por WhatsApp.
                </li>
                <li data-id="element-224">
                  Para mejorar el rendimiento del sitio y la experiencia del
                  usuario.
                </li>
                <li data-id="element-225">Para mantener la seguridad y prevenir fraude.</li>
              </ul>
            </section>

            <section data-id="element-226">
              <h2 className="font-heading text-2xl text-navy mb-3" data-id="element-227">Cookies</h2>
              <p data-id="element-228">
                Podemos utilizar cookies o tecnologías similares para medir
                tráfico y mejorar el sitio. Puedes controlar cookies desde la
                configuración de tu navegador. Desactivar cookies puede afectar
                algunas funciones.
              </p>
            </section>

            <section data-id="element-229">
              <h2 className="font-heading text-2xl text-navy mb-3" data-id="element-230">
                Cumplimiento GDPR (EEE/Reino Unido)
              </h2>
              <p data-id="element-231">
                Si te encuentras en el Espacio Económico Europeo o Reino Unido,
                procesamos datos bajo bases legales como consentimiento e
                intereses legítimos. Puedes solicitar acceso, corrección,
                eliminación o restricción del tratamiento, y retirar tu
                consentimiento cuando aplique.
              </p>
            </section>

            <section data-id="element-232">
              <h2 className="font-heading text-2xl text-navy mb-3" data-id="element-233">Contacto</h2>
              <p data-id="element-234">
                Para solicitudes relacionadas con privacidad, contáctanos por
                WhatsApp: <strong className="text-navy" data-id="element-235">+1 786 397 5041</strong>
              </p>
            </section>
          </div>
        </article>
      </main>
      <Footer data-id="element-236" />
    </div>;
}